// Inline validation — a lightweight client-side addition (doesn't replace server validation).
// Returns an error string if invalid, undefined if valid. Server validation (apiValidationErrors)
// remains authoritative on submit; this just gives immediate feedback as fields are edited.

import type { CrudField } from '../crud/types';

export function validateField(field: CrudField, value: unknown): string | undefined {
  // Required check
  if (field.required) {
    if (value == null || value === '' || (Array.isArray(value) && value.length === 0)) {
      return `${field.label} is required.`;
    }
  }

  // Type-specific checks
  if (field.type === 'number' && value !== '' && value != null) {
    const n = Number(value);
    if (!Number.isFinite(n)) return `${field.label} must be a number.`;
  }

  // No client rule → defer to server
  return undefined;
}
